import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgramsService } from '../../services/programs.service';
import { Program } from '../../models/programs.model';
import { ToastService } from '../../services/toast.service';
import { DynamicContentViewerComponent } from '../../components/dynamic-content-viewer/dynamic-content-viewer.component';

@Component({
  selector: 'app-program-details',
  imports: [DynamicContentViewerComponent],
  templateUrl: './program-details.component.html',
  styles: `
    .square {
      width: 10px;
      height: 10px;
      background-color: #437a77;
      display: inline-block;
      margin-right: 10px;
    }
  `
})
export class ProgramDetailsComponent implements OnInit {
  programId?: string;
  program?: Program;

  private route = inject(ActivatedRoute);
  private programsService = inject(ProgramsService);
  private toast = inject(ToastService);
  private router = inject(Router);

  ngOnInit() {
    this.programId = this.route.snapshot.paramMap.get('id')!;
    this.getProgram();
  }

  getProgram() {
    this.programsService.get(this.programId!).subscribe({
      next: (program) => {
        this.program = program;
      },
      error: (error) => {
        this.toast.error(error);
        this.router.navigate([
          '/programas',
          this.route.snapshot.paramMap.get('type')!
        ]);
      }
    });
  }
}
